import { ifElse } from 'ramda';

import { getOfferId } from 'app/router/selectors';
import { translationForKey } from 'app/features/localization/selectors';

const metaTitle = ifElse(
  getOfferId,
  translationForKey('offer_meta_title'),
  translationForKey('landing_meta_title'),
);

const metaDescription = ifElse(
  getOfferId,
  translationForKey('offer_meta_description'),
  translationForKey('landing_meta_description'),
);

export { metaTitle, metaDescription };
